import React, { Component } from "react";
import styled from "styled-components";
import { TableDefault, LabelString, LabelDollarFormatted, LabelDate } from "@loanbossinc/component-library";
import moment from 'moment';

const LOAN_LOCKOUT = "LOCKOUT";
const DEFAULT_LENDER_NAME = "Lender Selection Needed";

const StyledLabelString = styled(LabelString)`&&{
    /* Work Sans / 12 */

    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    /* identical to box height */

    display: flex;
    align-items: flex-end;

    /* Fill / Dark Gray */

    color: #5F6368;
}`

export class QuoteHistoryBodyList extends Component {
    loanTableCols = () => {
        return [
            {
                id: 'loan'
                , label: 'LENDER'
                , path: 'loan'
                , Cell: (value) => {
                    return (
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            {value.lenderCompanyName && <LabelString value={value.lenderCompanyName} />}
                            <StyledLabelString value={value.loanSubText} />
                        </div>
                    )
                }
            }
            , {
                id: 'amount'
                , label: 'QUOTE AMOUNT'
                , path: 'amount'
                , Cell: (value) => <LabelDollarFormatted value={value} decimals={0} />
            }

            , {
                id: 'term'
                , label: 'TERM'
                , path: 'term'
                , Cell: (value) => (
                    <LabelString value={value} />
                )
            }
        ]
    }

    getLoanSeniority = (loan) => {
        if (!loan || !loan.loanSeniority || !loan.loanSeniority.value) return null;
        const closingDate = !loan.closingDate ? "" : `- ${moment(loan.closingDate).format('YYYY')}`;
        return `${loan.loanSeniority.value} ${closingDate}`.trim();
    }

    getLenderCompanyName = (loan) => {
        if (!loan || !loan.lenderCompany || !loan.lenderCompany.name) return DEFAULT_LENDER_NAME;
        const lenderCompanyName = loan.lenderCompany.name;
        return lenderCompanyName.length > 20 ? `${loan.lenderCompany.name.slice(0, 20)} ... ` : lenderCompanyName;
    }

    getLoanTypeName = (loan) => {
        if (!loan || !loan.loanType || !loan.loanType.name) return DEFAULT_LENDER_NAME;
        const loanTypeName = loan.loanType.name;
        return loanTypeName.length > 20 ? `${loan.loanType.name.slice(0, 20)} ... ` : loanTypeName;
    }

    getColumnData = () => {
        const { loans } = this.props;
        return loans.reduce((acc, cur) => {

            acc.push({
                id: cur.id
                , term: cur.loanTermMonths
                , amount: cur.amount
                , loan: {
                    lenderCompanyName: this.getLenderCompanyName(cur),
                    loanSubText: `${this.getLoanSeniority(cur)} - ${this.getLoanTypeName(cur)}`
                }
            })
            return acc;
        }, []);
    }

    render() {
        const { toLoanDetails } = this.props;
        return (
            <div>
                <TableDefault
                    elevation={0}
                    columns={this.loanTableCols()}
                    items={this.getColumnData()}
                    onRowClick={(loan) => { toLoanDetails(loan.id) }} />
            </div>
        )
    }
}